import React from "react";
import { useState,useEffect } from "react";
import { useParams,useLocation,useNavigate,useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import './classes/DiscountList.css';
 import { DataGrid } from '@mui/x-data-grid';
 import { configData } from "../config";

 import { Link } from '@mui/material';
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";



    const columns = [   
  {
    field: 'discount_name',
    headerName: 'Discount Name',  
    cellClassName:'discount_name_column',headerClassName:'discount_name_header',    
    flex:1,
    sortable:false,
    minWidth:150,
  },
  {
    field: 'price',
    headerName: 'PRICE/AMOUNT',    
    cellClassName:'price_column',headerClassName:'price_header',
    flex:1,
    sortable:false,
    minWidth:145,
  },
  {
    field: 'offer_type',
    headerName: 'Offer Type',   
    cellClassName:'offer_type_column',headerClassName:'offer_type_header',
    flex:1,
    sortable:false,
    minWidth:110,
  },
    {
    field: 'start_date',
    headerName: 'Start Date',   
    cellClassName:'start_date_column',headerClassName:'start_date_header',
    flex:1,
    sortable:false,
    minWidth:65,
  },
    {
    field: 'end_date',
    headerName: 'End Date',   
    cellClassName:'end_date_column',headerClassName:'end_date_header',
    flex:1,
    sortable:false,
    minWidth:65,
  },
    {
    field: 'status',
    headerName: 'Status',   
    cellClassName:'status_column',headerClassName:'status_header',
    flex:1,
    sortable:false,
    minWidth:45,
  },
    {
    field: 'operations',
    headerName: 'Operations',
    cellClassName:'operations_column',headerClassName:'operations_header',   
    flex:1, 
    sortable:false,
    minWidth:70,
    renderCell: (params) => (
    <>
    <Link href={params.row.edit_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2",marginRight:"16px"}}>
    {params.row.linkText || 'Edit'}
    </Link> 
    <Link href={params.row.delete_url} target="_blank" rel="noopener noreferrer" style={{ color: "#2C99D2"}}>
    {params.row.linkText || 'Delete'}
    </Link>
    </>
),
    
  },
  

];

const DiscountList = () => {
    const initialForm = {
        discount_name:'',
        offer_type:'',
        discount_type:'',
        discount_status:'1'
    };
 const [appliedFormData, setAppliedFormData] = useState({
        discount_name:'',
        offer_type:'',
        discount_type:'',
        discount_status:'1'
      });
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState(initialForm);   
    const [submittedData, setSubmittedData] = useState(null);
    const [rows, setRows] = React.useState([]);
    const [rowCount, setRowCount] = React.useState(0);
    const [paginationModel, setPaginationModel] = React.useState({ page: 0, pageSize: 50 });
    const [sortModel, setSortModel] = React.useState([]);
    const [filterModel, setFilterModel] = React.useState({ items: [] });

    const app_url = configData.APP_URL;
    const location  = useLocation();
   
   const[successMessage,setSuccess] = useState('');
    const Message = location.state?.message; // Access the message
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
useEffect(() => {
  if (Message) {
    setSuccess(Message);
    window.history.replaceState({}, '');
  }
}, [Message, location.state]);
    React.useEffect(() => {
        const fetchData = async () => {
          // Simulate API call to your server
          // In a real application, replace this with your actual fetch logic
           try {
            setIsLoading(true);
          const response = await fetch(app_url+'smwwcommercediscount/getlist', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              page: paginationModel.page,
              pageSize: paginationModel.pageSize,
              sortModel,
              filterModel,
              //formData:formData
              formData:appliedFormData,
            }),
          });
          const data = await response.json();
          console.log(data.data.rows);
          setRows(data.data.rows);
          setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          }  catch (error) {
                console.error('Error fetching data:', error);
              } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
              }
        };
        
    
        fetchData();
      }, [paginationModel, sortModel, filterModel,appliedFormData]); // Re-fetch data when these change
    
    
      /* Pagination, filter config ends here */
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      setSubmittedData(formData);
      setPaginationModel({
                 page: 0,
                    pageSize: 50,
                 });
      setAppliedFormData({ ...formData });
      try {
         setIsLoading(true);
    const response = await fetch(app_url+'smwwcommercediscount/getlist', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              page:0,
              pageSize:50,
              sortModel,
              filterModel,
              formData:formData
            }),
          });
          const data = await response.json();
          console.log(data.data.rows);
          setRows(data.data.rows);
          setRowCount(data.data.totalRowCount); // Server should return totalRowCount
          setSuccess('');
          }  catch (error) {
                console.error('Error fetching data:', error);
              } finally {
                setIsLoading(false); // Set loading to false after fetch completes (success or error)
              }
      
    }; 

   
  
 
  

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : ( 
                <div id="main">
                    <Helmet><title>Discount List</title></Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                      <h1>Discount List</h1>
                         {successMessage && (
                        <div className="set-message-done">
                          <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span> {successMessage}
                        </div>
                        )}
                        <div  className="edit-discount-container">
                            <div>                               
                                <form onSubmit={handleSubmit}>
                                    <div>
                                      <label>
                                    Discount Name 
                                  </label>
                                  <input                                    
                                    type="text"
                                    className="form-text"
                                    name="discount_name"
                                    value={formData.discount_name}
                                    onChange={handleChange}
                                  />
                                  </div>
                                   <div>
                                    <label>
                                        Offer Type
                                    </label>
                                    <select
                                        id="offer_type"
                                        name="offer_type"
                                        value={formData.offer_type}
                                        onChange={handleChange}
                                    >
                                         <option value="">-Select-</option>
                                        <option value="0">$ off</option>
                                        <option value="1">% off</option>                                                
                                    </select>
                                </div>
                                    <div>
                                    <label>
                                        Discount Type
                                    </label>
                                    <select
                                        id="discount_type"
                                        name="discount_type"
                                        value={formData.discount_type}
                                        onChange={handleChange}
                                    >
                                         <option value="">-Select-</option>
                                        <option value="1">Country Discount</option>
                                        <option value="2">Product Discount</option>
                                        <option value="3">Referral Discount</option>        
                                    </select>
                                </div>
                                
                                     <div>        
                                    <label>
                                        Discount Status
                                    </label>
                                    <select
                                        id="discount_status"
                                        name="discount_status"
                                        value={formData.discount_status}
                                        onChange={handleChange}
                                    >
                                        <option value="1">Active</option>
                                        <option value="2">Disabled</option>
                                        <option value="3">Archive</option>        
                                    </select>
                                </div>
                                    <input type="submit" name="apply" value="Apply" style={{width:"155px",height: "30px",background: "#004b85",border:"none",color:"#fff"}} className="form-submit"/>
                             </form>
                             <a href="/admin/smww-commerce/discount-create">Add a Discount</a>
                               
                            </div>
                            
                                    <div style={{marginTop:"20px"}} className="discount-list-content">
                                        <table className="discount-list-table">
                                            <div style={{ width: '100%' }}>
                                                <DataGrid
                                                    rows={rows}
                                                    columns={columns}
                                                    rowCount={rowCount}
                                                    paginationMode="server"
                                                    sortingMode="server"
                                                    filterMode="server"
                                                    paginationModel={paginationModel}
                                                    onPaginationModelChange={setPaginationModel}
                                                    sortModel={sortModel}
                                                    onSortModelChange={setSortModel}
                                                    filterModel={filterModel}
                                                    onFilterModelChange={setFilterModel}
                                                    pageSizeOptions={[5, 10, 25,50]}
                                                    getRowId={() => crypto.randomUUID()}
                                                    getRowHeight={() => 'auto'}
                                                    disableColumnFilter 
                                                    //disableColumnResize={true}
                                                />
                                            </div>
                                        </table>
                                    </div>
                             
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar/>
                    </div>
                </div>
            )}
        </>
    );
};
export default DiscountList;